var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlaHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_8810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0615 31.0615 40 20 40C9.05028 40.1117 0 31.0615 0 20C0 9.05028 8.93855 0 20 0C31.0615 0 40 8.93855 40 20ZM20 37.2067C29.4972 37.2067 37.2067 29.4972 37.2067 20C37.2067 10.5028 29.4972 2.7933 20 2.7933C10.5028 2.7933 2.7933 10.5028 2.7933 20C2.7933 29.4972 10.5028 37.2067 20 37.2067Z",
    fill: "#F0CF2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6531 19.9976C17.6531 22.4557 17.6531 24.802 17.6531 27.2601C17.6531 28.2657 16.9827 28.9361 16.0888 28.8244C15.3067 28.7126 14.748 28.154 14.748 27.2601C14.748 25.249 14.748 23.2378 14.748 21.2266C14.748 18.3216 14.748 15.5283 14.748 12.6233C14.748 11.6177 15.4184 10.9473 16.424 11.059C16.9827 11.1707 17.5413 11.6177 17.5413 12.1763C17.5413 12.3998 17.5413 12.6233 17.5413 12.735C17.6531 15.3048 17.6531 17.6512 17.6531 19.9976Z",
    fill: "#F0CF2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1394 19.9964C25.1394 22.4545 25.1394 24.9126 25.1394 27.3707C25.1394 27.9294 24.9159 28.3763 24.3573 28.7115C23.9104 28.935 23.4634 28.935 22.9048 28.7115C22.5696 28.488 22.3461 28.1528 22.2344 27.7059C22.2344 27.4825 22.2344 27.3707 22.2344 27.1473C22.2344 22.4545 22.2344 17.6501 22.2344 12.9573C22.2344 12.6221 22.2344 12.3987 22.3461 12.0635C22.5696 11.3931 23.24 11.0579 23.9104 11.1696C24.5807 11.2813 25.0277 11.84 25.0277 12.6221C25.0277 14.4098 25.0277 16.3093 25.0277 18.097C25.1394 18.7674 25.1394 19.4378 25.1394 19.9964Z",
    fill: "#F0CF2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_8810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaHold);
export default __webpack_public_path__ + "static/media/slaHold.8423fb624ee6448cdd79c4a9a4da3ca3.svg";
export { ForwardRef as ReactComponent };